export const isTokenV1 = (token) => token.__typename === "MarketplaceTokenWithStats";
